import {formattedPropertyModel, intlShape} from '@wallaby-ui/core';
import {isNil, isObject} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './DecimalFormatter.less';
import {CELL_RENDERER_PARAMS_AG} from 'src/js/model/cell_renderer_params';

class DecimalFormatter extends React.PureComponent {
  render() {
    const {colDef, intl, value} = this.props;
    const propDefinition = new formattedPropertyModel.FormattedProperty({
      type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_DECIMAL,
      ...(colDef && isObject(colDef[CELL_RENDERER_PARAMS_AG])
        ? {parameters: {...colDef[CELL_RENDERER_PARAMS_AG]}}
        : {}),
      intl,
    });
    const formattedValue = !isNil(value)
      ? formattedPropertyModel.FormattedProperty.formatValue(
          propDefinition,
          value,
          intl
        )
      : '';
    return !isNil(value) ? (
      <div className={styles.dlDecimalFormatter} title={formattedValue}>
        {formattedValue}
      </div>
    ) : (
      ''
    );
  }
}

DecimalFormatter.displayName = 'DecimalFormatter';

DecimalFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

DecimalFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(DecimalFormatter);
